import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Product } from '../../../models/product';
import { declerationLinearText } from '../../../models/contitions';
import { UtilsService } from '../../../services/utils.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgGreenLinearModalComponent } from '../../dialogs/alg-green-linear-modal/alg-green-linear-modal.component';
import { Promotion } from '../../../models/promotion';
import { Onboarding } from '../../../models/onboarding';

@Component({
  selector: 'alg-green-energy',
  templateUrl: './alg-green-energy.component.html',
  styleUrls: ['./alg-green-energy.component.scss'],
})
export class AlgGreenEnergyComponent implements OnInit {
  @Input() sidebar: boolean;
  @Input() isModalOpenMobile: boolean;

  public product: Product;
  public onboarding: Onboarding;
  public greenEnergy: boolean;
  public isEnergyFaqClicked: boolean;
  public activateGreen: boolean;
  public promotions: Promotion[];
  public disableGreenSwitch: boolean;
  public textGreenPromoCode: boolean;

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct, this.api.currentLightGreen)
      .subscribe(([onboarding, product, lightGreen]) => {
        this.product = product;
        this.onboarding = onboarding;
        this.api.currentLightGreen.subscribe((value) => {
          this.greenEnergy = value;
        });
        this.api.promotions.subscribe((promotions: Promotion[]) => {
          this.promotions = promotions;
        });
        this.disableGreenOnPromo();
        if (this.onboarding.promoCode === null || undefined || '') {
          this.textGreenPromoCode = false;
          this.disableGreenSwitch = false;
        }
      });
    this.api.updateGreenEnergyPromo.subscribe((value) => {
      this.textGreenPromoCode = value;
      this.disableGreenSwitch = value;
    });
  }

  changeGreenEnergy(value) {
    this.api.currentLightGreen.next(value);
  }

  disableGreenOnPromo() {
    for (let i = 0; i < this.promotions.length; i++) {
      if (this.promotions[i].enableGreenPromo) {
        if (this.onboarding.promoCode === this.promotions[i].code) {
          this.disableGreenSwitch = true;
        }
      }
    }
  }

  activateGreenEnergy(value) {
    if (!this.greenEnergy) {
      this.changeGreenEnergy(value);
      this.isEnergyFaqClicked = false;
    } else {
      this.isEnergyFaqClicked = false;
    }
  }

  readCondition() {
    if (this.isModalOpenMobile) {
      this.isEnergyFaqClicked = true;
    } else {
      let modalContent;
      modalContent = declerationLinearText.greenEnergy;
      this.openModalGreen(modalContent);
    }
  }

  openModalGreen(modalContent) {
    this.utils.disableOverflow();

    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgGreenLinearModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
        modalClass: 'modal fade ngx-modal alternative-modal-green-energy',
        contentClass: 'modal-content-green included-linear-modal',
      },
      data: {
        description: modalContent.description,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-green-energy/alg-green-energy.component.ts